import * as schemas from "./schemas";
import { CLIENT_TOKEN } from "shadow-client";
import generator from "shadow-client/endpoints/generator";

// clubs
const clubGenerator = generator.with(`/${CLIENT_TOKEN}/clubs`, schemas.club);
export const fetchClubList = clubGenerator.fetchEntityList;
export const fetchClub = clubGenerator.fetchEntity;



// WEBPACK FOOTER //
// ./src/shadow-client/endpoints/clubApi/index.js